import React, { useEffect, useState } from "react";
import SelectSearchInputParam from "views/pages/manage/edpOps/studentSerach/SelectSearchInputParam";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";

const inputHeight = { height: "28px", width: "375px" };
const filterPlaceholder = {
  studentName: "Search by name",
  psid: "Student search by PSID",
  applicationId: "Search by application ID",
};
const maxLengthMap = {
  applicationId: 8,
  psid: 11,
  studentName: 50, // assuming max 50 characters for name input
};

const validationMap = {
  psid: /^[0-9]{0,11}$/, 
  applicationId: /^[0-9]{0,8}$/,
  studentName: /^[a-zA-Z ]{0,50}$/, // Only letters and space, at least one character
};

const SingleParamsFilter = ({ inputHandler, applicationId, psid }) => {
  const [searchCriteria, setSearchCriteria] = useState("psid");
  const [inputVal, setInputVal] = useState(applicationId || psid || null);

  const checkBoxChangeHandler = (newSearchCriteria) => {
    setInputVal("");
    setSearchCriteria(newSearchCriteria);
    console.log(newSearchCriteria);
  };

  useEffect(() => {
    if(applicationId || psid){
      const currentCtr = applicationId ? "applicationId" : "psid";
      setSearchCriteria(currentCtr)
      setInputVal(applicationId ||psid )
    }
  }, [applicationId, psid]);

  const searchHandler = (filter) => {
    const allKeys = ["psid", "applicationId", "studentName"];
   const  updatedFilter  = allKeys.reduce((acc, key) => {
      acc[key] = key === searchCriteria ? inputVal : "";
      return acc;
    }, {});
    inputHandler(updatedFilter);
  };

  const isValidInput = () => {
    if (searchCriteria === "psid" && inputVal?.length !== 11) {
      return false;
    }
    return true;
  };

  const handleSearch = () => {
    isValidInput() &&
      searchHandler({
        [searchCriteria]: inputVal,
      });
  };

  const handleCrossIconClick = () => {};

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      handleSearch();
    }
  };

  const handleInputChange = val => {
      const allowedPattern = validationMap[searchCriteria];
      const maxLength = maxLengthMap[searchCriteria];
      (val?.length <= maxLength) && allowedPattern.test(val) && setInputVal(val);
  }

  return (
    <div>
      <div style={{ width: "fit-content" }}>
        <AInput
          placeholder={filterPlaceholder[searchCriteria]}
          style={inputHeight}
          value={inputVal}
          handler={handleInputChange}
          onKeyDown={onKeyDown}
          // crossIcon={true}
          rightSearchIcon={true}
          searchIconClickHandler={handleSearch}
          crossHandler={handleCrossIconClick}
          maxLength={maxLengthMap[searchCriteria]}
          // onKeyPress={(e) => {
          //   const allowedPattern = validationMap[searchCriteria];
          //   const maxLength = maxLengthMap[searchCriteria];
          //   debugger
          //   if (!allowedPattern.test(e.key)) {
          //     debugger
          //     e.preventDefault();
          //   }
          // }}
        />
      </div>
      <SelectSearchInputParam
        searchInputParam={searchCriteria}
        setSearchInputParam={checkBoxChangeHandler}
        isRollNo={false}
      />
    </div>
  );
};

export default SingleParamsFilter;
